<template>
  <div style="padding: 15px">
    <vxe-toolbar id="toolbarId_bf15" :custom="{storage: true}" export>
      <template v-slot:buttons>
        <el-button @click="funcAdd">新增</el-button>
        <el-button @click="funcExport">导出</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      show-overflow
      row-id="id"
      height="500"
      :data="tableData"
      :loading="loading"
      export-config
    >
      <vxe-table-column field="violationTime" title="违章时间" min-width="100" />
      <vxe-table-column field="violationPlace" title="违章地址" min-width="100" />
      <vxe-table-column field="violationProject" title="违章行为" min-width="100" />
      <vxe-table-column field="penaltyAmount" title="违章罚款" min-width="100" />
      <vxe-table-column field="deductPoints" title="违章记分" min-width="100" />
      <vxe-table-column title="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="vehicleEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="vehicleCancel(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <vxe-modal v-model="modalAddFlag" title="新增" width="800" height="440" resize>
      <compAdd ref="AddRef" @hideModel="hideAddModel" />
    </vxe-modal>
    <vxe-modal v-model="modalEditFlag" title="编辑" width="800" height="440" resize>
      <compEdit ref="EditRef" @hideModel="hideEditModel" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { vehicleViolationCode, vehicleViolationDelete } from "@/api/vehicleService";
import compAdd from "./components/vehicleViolationAdd.vue";
import compEdit from "./components/vehicleViolationEdit.vue";
export default {
  name: "VehicleViolationDetail",
  components:{
	  compAdd,
	  compEdit
  },
  data() {
    return {
      exportObj:{
        exportUrl:"/ntocc-basic-api/vehicleViolation/exportDetailList",//导出接口
        name:'车辆违章详情列表'
      },
      modalAddFlag:false,
      modalEditFlag:false,
      tableData: [],
      loading: false,
      listQuery: {
        vehicleCode: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
    };
  },
  methods: {
	  // 新增
	  funcAdd(){
		  this.modalAddFlag = true
		  this.$refs.AddRef.getCode(this.listQuery.vehicleCode);
	  },
	  hideAddModel(value){
		  this.modalAddFlag = false
      if(value){
		    this.getInfo(value)
      }
	  },
	  // 删除
	  vehicleCancel(codes){
		this.$confirm("确认删除吗？").then(_ => {
		  vehicleViolationDelete({ codes }).then(response => {
		    this.$message({ message: response.msg, type: "success" });
		    this.getInfo();
		  });
		});
	  },
	  // 编辑
	  vehicleEdit(code){
		 this.modalEditFlag = true
		 this.$refs.EditRef.getDetail(code);
	  },
	  hideEditModel(value){
		  this.modalEditFlag = false
		  if(value){
		    this.getInfo(value)
      }
	  },
    getInfo(code) {
      this.loading = true;
      this.tableData = [];
      if (code) this.listQuery.vehicleCode = code
      vehicleViolationCode(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage
      this.listQuery.pageSize = pageSize
      this.getInfo()
    }
  }
};
</script>
